import axios from 'axios';
import { getApiUrl } from '../config/runtime';

const getApiBase = () => getApiUrl();

export interface Stream {
  id: number;
  user_id: number | null;
  device_id: number;
  channelID: string;
  channelType: 'twitch' | 'youtube' | 'kick';
  channelName?: string;
  profilePicture?: string;
  red: number;
  green: number;
  blue: number;
  islive: boolean;
  blink: boolean;
  priority: number;
  muted: boolean;
  watching: boolean;
  locked: boolean;
  created_at: string;
  updated_at: string;
}

const streamService = {
  getByDeviceId: async (deviceId: number) => {
    const response = await axios.get<{ streams: Stream[] }>(
      `${getApiBase()}/streams/device/${deviceId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data.streams;
  },

  create: async (
    deviceId: number,
    channelID: string,
    channelType: 'twitch' | 'youtube' | 'kick',
    red: number = 0,
    green: number = 0,
    blue: number = 0,
    blink: boolean = false,
    priority: number = 999
  ) => {
    const response = await axios.post<{ message: string; stream: Stream }>(
      `${getApiBase()}/streams`,
      {
        device_id: deviceId,
        channelID,
        channelType,
        red,
        green,
        blue,
        blink,
        islive: false,
        priority,
        muted: false,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data.stream;
  },

  delete: async (streamId: number) => {
    const response = await axios.delete<{ message: string }>(
      `${getApiBase()}/streams/${streamId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  },

  update: async (streamId: number, data: Partial<Stream>) => {
    const response = await axios.put<{ message: string; stream: Stream }>(
      `${getApiBase()}/streams/${streamId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data.stream;
  },
};

export default streamService;
